import React from "react";
export enum DatePattend {
  DayMonthYear = "dd/MM/yyyy",
  YearMonthDay = "yyyy/MM/dd",
  FullDateTime = "dd/MM/yyyy HH:mm:ss",
}
